import Response from "../../Data/Domain/Response";
import Nft from "../Domain/Nft";
import { getNfts } from "./Nfts.service";

export async function getNftsRepository(params) {
  const data = await getNfts(params);
  return new Response(data, Nft).getMultiple();
}